export class UserAgent {
    public static ipad() {
        return !!navigator.userAgent.match(/iPad/i);
    }

    public static iphone() {
        return !!navigator.userAgent.match(/iPhone/i);
    }

    public static ipod() {
        return !!navigator.userAgent.match(/iPod/i);
    }

    public static appleios() {
        return UserAgent.ipad() || UserAgent.ipod() || UserAgent.iphone();
    }

    public static android() {
        return !!navigator.userAgent.match(/Android/i);
    }

    public static linux() {
        return !!navigator.appVersion.match(/Linux/i);
    }

    public static windows() {
        return !!navigator.appVersion.match(/Win/i);
    }

    public static internetExploder() {
        return !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.indexOf('MSIE ') > 0;
    }
    
    public static mobile(): boolean {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    public static getDevice() {
        if (this.android()) return 'Android';
        if (this.ipad()) return 'iPad';
        if (this.iphone()) return 'iPhone';
        if (this.ipod()) return 'iPod';
        if (this.appleios()) return 'ios Device';
        if (this.windows()) return 'Windows';
        if (this.internetExploder()) return 'Internet Explorer';
        if (this.linux()) return 'Linux';
        else return 'Unknown Device';
    }
}
